import React from "react";
import { Box, TextField, Autocomplete } from "@mui/material";
import FormDialog from "@components/FormDialog";
import { useTranslation } from "react-i18next";
import { UnitGroup } from "@lib/types/unit_group";

interface Props {
  viewUnitGroupDialogOpen: boolean;
  setViewUnitGroupDialogOpen: (open: boolean) => void;
  unitGroupData?: UnitGroup;
}

const ViewUnitGroup: React.FC<Props> = ({
  viewUnitGroupDialogOpen,
  setViewUnitGroupDialogOpen,
  unitGroupData,
}) => {
  const { t } = useTranslation();

  return (
    <FormDialog
      title={t("user.unitGroups.view")}
      open={viewUnitGroupDialogOpen}
      onClose={() => setViewUnitGroupDialogOpen(false)}
      submitText={t("general.close")}
    >
      {unitGroupData && (
        <form noValidate>
          <Box display="flex" flexDirection="column" gap={2} py={2}>
            <TextField
              label={t("general.name")}
              variant="outlined"
              fullWidth
              value={unitGroupData.name}
              inputProps={{
                readOnly: true,
              }}
            />

            <Autocomplete
              multiple
              options={unitGroupData.units || []}
              value={
                unitGroupData.units?.filter((unit) =>
                  unitGroupData.units?.includes(unit)
                ) || []
              }
              disableClearable
              readOnly
              isOptionEqualToValue={(option, value) =>
                option.unit_id === value.unit_id
              }
              getOptionLabel={(option) => option.name || ""}
              renderOption={(props, option) => (
                <li {...props} key={`${option.name}-${option.unit_id}`}>
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("user.unitGroups.units")}
                  variant="outlined"
                />
              )}
            />
          </Box>
        </form>
      )}
    </FormDialog>
  );
};

export default ViewUnitGroup;
